import { AvatarProps, variantPropTypes, defaultProps } from './Avatar';

type ImageLoadingStatus = 'loaded' | 'loading' | 'pending' | 'failed';

export default function getVariant(props: AvatarProps & typeof defaultProps, status: ImageLoadingStatus): string {
  const { name, variant } = props;

  if (variant) return variant;

  if (status === 'loading') {
    return 'internalLoadingVariant';
  }

  return getVariantColorFromName(name, variantPropTypes);
}

function getVariantColorFromName(name: string, variantList: string[] = variantPropTypes): string {
  const variantIndex = name.length % variantList.length;

  return variantList[variantIndex];
}
